import React from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { OFAKIM_FORM_NAME } from 'apps/auth/constants/formName';

const KycOfakimDocAddPhotoPage = (props) => {
    return props.ofakimFields ? (
        <ModalComponent onCloseIconClick={props.onCloseClick}>
            <HeaderPanel title={props.title} />
            <Form
                id="ofakim_form_id"
                getCanonicalPath={true}
                beforeSubmit={props.beforeSubmit}
                onSubmitHandler={props.submitHandler}
                checkNotVisibleField={false}
                formName={OFAKIM_FORM_NAME}
            >
                {props.getFirstScreenFields(props.ofakimFields).map((f) => {
                    return (
                        <Row indent="adaptive-32-48" key={`fields_${f.name}`}>
                            <InputAutoDetect field={f} key={f.name} formName={OFAKIM_FORM_NAME} />
                        </Row>
                    );
                })}
                <FixedBottomPanel>
                    <Button
                        type="submit"
                        disabled={!props.isEnabled(props.getFirstScreenFields(props.ofakimFields))}
                        ref={props.submitRef}
                        caption={props.buttonContinue}
                        raised={true}
                    />
                </FixedBottomPanel>
            </Form>
        </ModalComponent>
    ) : null;
};

export default KycOfakimDocAddPhotoPage;
